import CollapseIcon from "@/assets/SVG/collapseIcon";
import DashboardIcon from "@/assets/SVG/dashboard";
import { Refresh } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getActiveGroups } from "../api/group";
import CardTitleGroup from "./cardTitleGroup";
import Logoutpop from "./logoutpop";

function Main({
  setShowSidebar,
  digest,
  childNode,
  title = "داشبورد شما",
  children,
}) {
  const [openPopoverLogout, setOpenPopoverLogout] = useState();

  const [dataGroupsActive, setDataGroupsActive] = useState();
  const md = useMediaQuery("(max-width:450px)");

  const fetchMyInfo = useCallback(() => {
    if (digest?.role === "ADMIN") {
      getActiveGroups()
        .then((x) => setDataGroupsActive(x))
        .catch(() => {});
    }
  }, [localStorage, digest]);

  useEffect(() => {
    if (digest) {
      fetchMyInfo();
    }
  }, [digest]);

  return (
    <>
      <Logoutpop
        openPopover={openPopoverLogout}
        pic={digest?.pic}
        name={digest?.name}
        setOpenPopover={setOpenPopoverLogout}
      />
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"20px"}
        padding={md ? "10px" : "10px 40px 40px 40px"}
        width={md ? "100%" : "calc(100% - 290px)"}
        sx={{
          overflow: "auto",
          margin: md ? 0 : "20px",
          borderRadius: md ? 0 : "10px",
          backgroundColor: "var(--emr-white)",
        }}
      >
        <Box
          display={"flex"}
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          {/* {dataGroupsActive ? (
            <CardTitleGroup
              pic={dataGroupsActive?.user?.pic}
              titr={dataGroupsActive?.areas[0]?.name}
              name={dataGroupsActive?.name}
            />
          ) : (
            <CardTitleGroup
              pic={image || groupPic}
              titr={dataMyInfo?.name}
              name={dataMyInfo?.groupName}
            />
          )} */}
          <Grid display={"flex"} alignItems="center" gap={"10px"}>
            {md && (
              <IconButton
                onClick={() => setShowSidebar(true)}
                sx={{
                  backgroundColor: "var(--emr-primary)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "var(--emr-primary)",
                  },
                }}
              >
                <DashboardIcon />
              </IconButton>
            )}
            {!md && <CollapseIcon />}

            <Typography color={"text.primary"}>{title}</Typography>
          </Grid>
          <Box display={"flex"} alignItems="center">
            {digest?.role === "ADMIN" &&
              !md &&
              dataGroupsActive &&
              dataGroupsActive.length > 0 && (
                <Grid
                  sx={{
                    backgroundColor: "var(--emr-background-silver)",
                    padding: "5px 10px",
                    borderRadius: "8px",
                  }}
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={"10px"}
                >
                  <Typography
                    sx={{ marginLeft: "15px" }}
                    variant="caption"
                    color={"text.secondary"}
                  >
                    {"گروه‌های در حال برگزاری اردو"}
                  </Typography>
                  <Grid display={"flex"} flexDirection={"row"}>
                    {dataGroupsActive?.map((group, index) => (
                      <Tooltip key={index} title={group.name}>
                        <img
                          style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            marginRight: "-15px",
                            zIndex: dataGroupsActive.length - index,
                            border: "2px solid var(--emr-primary)",
                          }}
                          src={group.pic}
                        />
                      </Tooltip>
                    ))}
                  </Grid>
                </Grid>
              )}

            {digest?.role !== "ADMIN" && digest?.role !== "GROUP" && (
              <IconButton
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "var(--emr-background-silver)",
                }}
                onClick={() => {
                  localStorage.removeItem("my_accesses");
                  localStorage.removeItem("user_digest");
                  const keysToRemove = [];
                  const prefix = "area_data_";
                  for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key.startsWith(prefix)) {
                      keysToRemove.push(key);
                    }
                  }

                  keysToRemove.forEach((key) => {
                    localStorage.removeItem(key);
                  });
                  toast.success("کش با موفقیت پاک شد");
                }}
              >
                <Refresh />
              </IconButton>
            )}

            <CardTitleGroup
              pic={digest?.pic}
              titr={
                digest?.role === "ADMIN"
                  ? "مسئول کل"
                  : digest?.role === "GROUP"
                    ? "مسئول گروه"
                    : digest?.hasActiveRegion === true
                      ? "مسئول منطقه"
                      : "جهادگر"
              }
              profile
              name={digest?.name}
              onClick={(e) => setOpenPopoverLogout(e.currentTarget)}
            />
          </Box>
        </Box>
        {/* {digest?.role === "ADMIN" &&
          md &&
          dataGroupsActive &&
          dataGroupsActive.length > 0 && (
            <Grid
              sx={{
                backgroundColor: "var(--emr-background-silver)",
                padding: "5px 10px",
                borderRadius: "8px",
              }}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={"10px"}
            >
              <Typography
                sx={{ marginLeft: "15px" }}
                variant="caption"
                color={"text.secondary"}
              >
                {"گروه‌های در حال برگزاری اردو"}
              </Typography>
              <Grid display={"flex"} flexDirection={"row"}>
                {dataGroupsActive?.map((group, index) => (
                  <Tooltip key={index} title={group.name}>
                    <img
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        marginRight: "-15px",
                        zIndex: dataGroupsActive.length - index,
                        border: "2px solid var(--emr-primary)",
                      }}
                      src={group.pic}
                    />
                  </Tooltip>
                ))}
              </Grid>
            </Grid>
          )} */}

        {childNode || children}
      </Grid>
    </>
  );
}

export default Main;
